var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "search-menu-container",
      attrs: { tabindex: "2" },
      on: { blur: _vm.hideSearchMenu }
    },
    [
      _c(
        "div",
        {
          staticClass: "search-menu-placeholder",
          on: {
            click: function($event) {
              return _vm.onClick()
            }
          }
        },
        [
          _c("span", { staticClass: "search-menu-placeholder-text" }, [
            _vm._v(_vm._s(this.placeholder) + " "),
            _c("i", { staticClass: "far fa-chevron-down" })
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "search-menu-entries",
          class: { open: _vm.menuShowing }
        },
        [_vm._t("default")],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }